const API_ENDPOINTS = {
  FEATURED_PROPERTIES: "/properties/featured/",
  RECOMMENDED_PROPERTIES: "/properties/recommended/",
  HOME_PROJECT_DATA: "/project/home-project-data/",
  OFFERS_HOME: "/offers/my/",
  CITY_FROM_COORDINATES: "/maps/api/geocode/json",
  AUTHENTICATE: "/auth/generate-login-otp/",
  GENERATE_OTP: "/auth/generate-otp/",
  VERIFY_OTP: "/auth/verify-otp/",
  USER_LOGIN: "/auth/verify-otp/",
  REGISTER_USER: "/auth/register/",
  USER_PROFILE: "/auth/profile/",
  UPDATE_FREE_VIEW_POST_LIMIT: "/cust_api/add_count",
  GET_PROPERTY_DETAILS: "/cust_api/get_property_details",
  GET_PROJECT_DETAILS: "/cust_api/get_project_details",
  RECORD_VIEW: "/api/views/",
  MARK_FAVORITE: "/cust_api/add_to_favorite",
  REMOVE_FAVORITE: "/cust_api/remove_from_favorite",
  MARK_PROJECT_FAVORITE: "/cust_api/add_favorite_project",
  REMOVE_PROJECT_FAVORITE: "/cust_api/remove_favorite_project",
  OFFERS_CREATE: "/offers/create/",
  OFFERS_MY: "/offers/my/",
  OFFERS_TYPE_GET: "/offers/offers_type/get/",
  PROPERTIES_CREATE: "/properties/create/",
  PROPERTIES_UPDATE: "/properties/update/",
  PROPERTIES_COVER_IMAGE: (id) => `/properties/${id}/cover-image/`,
  PROPERTIES_IMAGES: (id) => `/properties/${id}/images/`,
  PROPERTIES_VIDEO: (id) => `/properties/${id}/video/`,
  PROPERTIES_VIDEO_STATUS: (id) => `/properties/${id}/video-status/`,
  PROPERTIES_AMENITIES: "/properties/amenities/",
  PROPERTIES_PHOTO_DELETE: "/properties/photo/delete/",
  PROPERTIES_AVAILABILITY: (id) =>
    `/properties/availability/?property_id=${id}`,
  PROPERTIES_ARCHIVE: (id) => `/properties/archive/?property_id=${id}`,
  PROPERTIES_CITIES: "/properties/cities/",
  SEARCH_UNIFIED: "/api/search/",
  SEARCH_MAP: "api/search/map/",
  PROPERTIES_MAP_RADIUS: "/properties/map-radius/",
  PROJECTS_CREATE: "/project/projects/",
  PROJECTS_UPDATE: "/project/projects/",
  PROJECTS_DETAIL: "/project/projects/",
  PROJECTS_MY_DASHBOARD: "/project/my-project/",
  PROJECTS_COVER_LOGO: "/project/projects/cover_logo_bro/",
  PROJECTS_VIDEO: "/project/projects/video/",
  PROJECTS_GALLERY: "/project/project_images/",
  PROJECTS_GALLERY_DELETE: (id) => `/project/project_images/${id}/`,
  PROJECTS_SYNC_UNITS: "/project/project-properties/",
  PROJECTS_UNIT_IMAGES: "/project/project-property/images/bulk/",
  PROJECTS_AMENITIES: "/project/amenities/",
  PROJECTS_ALL: "/cust_api/all_project_list",
  GENERATE_ABOUT: "/project/projects/generate-about/",
  STATIC_PAGE: (id) => `/admin-portal/static-page/${id}/`,
  LEADS: "/leads/",
  FAVORITES_TOGGLE: "/api/favorites/toggle/",
  FAVORITES_LIST: "/api/favorites/",
  FEEDBACK: "/api/feedback/",
  UNLOCK_CONTACT: "/api/unlock-contact/",
  SAVED_SEARCH_CREATE: "/api/saved-search/create/",
  SAVED_SEARCH_LIST: "/api/saved-search/list/",
  SAVED_SEARCH_DELETE: (id) => `/api/saved-search/${id}/`,
  VIRTUAL_TOUR: "/virtual_tour/",
  VIRTUAL_TOUR_ACTION: (id) => `/virtual_tour/${id}/action/`,
  VIRTUAL_TOUR_JOIN_TOKEN: (id) => `/virtual_tour/${id}/token/`,
  // Subscriptions API v2 — customer endpoints
  SUBSCRIPTIONS_PLANS: "/subscriptions/plans/",
  SUBSCRIPTIONS_FEATURES: "/subscriptions/features/",
  SUBSCRIPTIONS_CREATE_ORDER: "/subscriptions/create-order/",
  SUBSCRIPTIONS_CREATE_CUSTOM_ORDER: "/subscriptions/create-custom-order/",
  SUBSCRIPTIONS_VERIFY_PAYMENT: "/subscriptions/verify-payment/",
  SUBSCRIPTIONS_RETRY_PAYMENT: "/subscriptions/retry-payment/",
  SUBSCRIPTIONS_MY_PLAN: "/subscriptions/my-plan/",
};

export default API_ENDPOINTS;
